import { createSelector } from 'redux-orm';

import orm from '../orm';

export const makeSelectListReportDataByListId = () =>
  createSelector(
    orm,
    (_, listId) => listId,
    ({ ListReportData }, listId) => {
      if (!listId) {
        return null;
      }

      const listReportDataModel = ListReportData.all()
        .filter({ listId })
        .first();

      if (!listReportDataModel) {
        return null;
      }

      return listReportDataModel.ref;
    },
  );

export const selectListReportDataByListId = makeSelectListReportDataByListId();

export default {
  makeSelectListReportDataByListId,
  selectListReportDataByListId,
};
